// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3350-"};